import { render, staticRenderFns } from "./mValueWave.vue?vue&type=template&id=027b137a&scoped=true"
import script from "./mValueWave.vue?vue&type=script&lang=js"
export * from "./mValueWave.vue?vue&type=script&lang=js"
import style0 from "./mValueWave.vue?vue&type=style&index=0&id=027b137a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b137a",
  null
  
)

export default component.exports